/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Driver_Phone_PlaceholderInputs */

const en_case_field_driver_phone_placeholder = /** @type {(inputs: Case_Field_Driver_Phone_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(11) 99876-5432`)
};

const pt_br2_case_field_driver_phone_placeholder = /** @type {(inputs: Case_Field_Driver_Phone_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(11) 99876-5432`)
};

/**
* | output |
* | --- |
* | "(11) 99876-5432" |
*
* @param {Case_Field_Driver_Phone_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_driver_phone_placeholder = /** @type {((inputs?: Case_Field_Driver_Phone_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Driver_Phone_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_driver_phone_placeholder(inputs)
	return pt_br2_case_field_driver_phone_placeholder(inputs)
});